var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScopeoverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5975 23C5.74752 23 1.49752 19.55 0.497522 14.8C-0.102478 12.1 0.397522 9.35002 1.89752 7.00002C3.39752 4.70002 5.69752 3.10002 8.39752 2.50002L8.89752 2.40002L11.0475 12.4L17.1475 20.65L16.7475 20.95C15.5475 21.85 14.1975 22.45 12.7475 22.75C12.0475 22.9 11.3475 23 10.5975 23ZM8.14752 3.60002C5.89752 4.20002 3.99752 5.60002 2.74752 7.55002C1.39752 9.65002 0.947522 12.15 1.44752 14.6C2.34752 18.9 6.19752 22 10.5975 22C11.2475 22 11.9475 21.95 12.5975 21.8C13.7475 21.55 14.8475 21.1 15.7975 20.45L10.1475 12.85L8.14752 3.60002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8469 12.2L9.54688 1.35L10.0469 1.25C10.7469 1.1 11.4469 1 12.1969 1C15.3469 1 18.2469 2.4 20.2469 4.85L20.5469 5.25L11.8469 12.2ZM10.6969 2.1L12.4969 10.45L19.1969 5.15C17.3969 3.1 14.8969 2 12.1969 2C11.6969 2 11.1969 2.05 10.6969 2.1Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1453 21.55L12.6953 12.85L21.1453 6.09998L21.4453 6.49998C22.4453 7.74998 23.1453 9.19998 23.4953 10.8C24.3453 14.75 22.7953 18.9 19.5453 21.3L19.1453 21.55ZM14.0453 13L19.3453 20.2C22.0453 18 23.2953 14.4 22.5453 11C22.2453 9.69998 21.7453 8.54998 20.9953 7.49998L14.0453 13Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScopeoverview);
export default __webpack_public_path__ + "static/media/scopeoverview.06df857ea5c70e9b49db867b58dd8892.svg";
export { ForwardRef as ReactComponent };